import { STUDIO_LOCATOR } from "../../constants";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-section">
        <div>
          <p>AVAILIBILITY IN</p>
          <a href={STUDIO_LOCATOR}>INTERNATIONAL CITIES</a>
        </div>
        <div>
          <p>LANGUAGE</p>
          <a href={STUDIO_LOCATOR}>ENGLISH (CHANGE)</a>
        </div>
      </div>

      <div className="footer-section">
        <div>
          <a href={STUDIO_LOCATOR}>CLIENT SERVICE</a>
          <a href={STUDIO_LOCATOR}>SUSTAINIBILITY</a>
          <a href={STUDIO_LOCATOR}>FAQS</a>
          <a href="mailto:ankitbhardwaj.uk@gmail.com">
            ankitbhardwaj.uk@gmail.com
          </a>
          <a href="tel:+919205591541">+91 920 559 1541</a>
          <a href={STUDIO_LOCATOR}>MAKE AN APPOINTMENT</a>
        </div>
      </div>

      <div className="footer-section">
        <div>
          <p>CAREER</p>
          <a href={STUDIO_LOCATOR}>LEGAL NOTICES</a>
          <a href={STUDIO_LOCATOR}>ACCESSIBILITY</a>
          <a href={STUDIO_LOCATOR}>COOKIES SETTINGS</a>
        </div>
      </div>

      <div className="footer-section">
        <div>
          <a href="https://www.facebook.com/meridiansproperties?mibextid=kFxxJD">
            FACEBOOK
          </a>
          <a href="https://twitter.com">X</a>
          <a href="https://www.instagram.com/ankitatelierofficial?igsh=ejN4dGlkcnY1N2Y5&utm_source=qr">
            INSTAGRAM
          </a>
          <a href="https://youtube.com/@ankitdesignanddevelopmentateli?si=KDAVwF7J-e5jNqZ8">
            YOUTUBE
          </a>
        </div>
      </div>

      <div className="footer-section">
        <div>
          <a href={STUDIO_LOCATOR}>SUBSCRIBE TO THE NEWSLETTER</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
